import { styled } from "@mui/material/styles";
import { Box, Card, CardContent, Button, Chip } from "@mui/material";
import { PlayArrow as PlayIcon } from "@mui/icons-material";

// Styled components for enhanced UI
export const StyledVideosCard = styled(Card)(({ theme }) => ({
  height: "auto",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(2),
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  transition: "box-shadow 0.3s ease",
  "&:hover": {
    boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
  },
}));

export const VideosHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const VideosContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(2), // Reduced padding from 3 to 2
  paddingTop: theme.spacing(1), // Reduced top padding from 2 to 1
  "&:last-child": {
    paddingBottom: theme.spacing(2), // Override MUI's default paddingBottom on last child
  },
}));

export const ActionButton = styled(Button)(() => ({
  borderRadius: 20,
  padding: "8px 20px",
  textTransform: "none",
  fontWeight: 600,
}));

export const VideoCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== "isProcessed",
})(({ theme, isProcessed }) => ({
  borderRadius: theme.spacing(1.5),
  overflow: "hidden",
  transition: "transform 0.2s ease, border 0.3s ease",
  "&:hover": {
    transform: "scale(1.03)",
  },
  cursor: "pointer",
  border: isProcessed
    ? `1px solid ${theme.palette.success.main}`
    : `1px solid ${theme.palette.warning.main}`,
}));

export const VideoThumbnail = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isProcessed",
})(({ isProcessed }) => ({
  position: "relative",
  "&::after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: isProcessed
      ? "rgba(76, 175, 80, 0.1)" // Green tint for processed
      : "rgba(255, 152, 0, 0.1)", // Orange tint for unprocessed
  },
}));

export const ThumbnailContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  height: 160,
  backgroundColor: "black",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    height: 140, // Slightly smaller on mobile
  },
}));

export const StatusChip = styled(Chip)(() => ({
  position: "absolute",
  top: 8,
  right: 8,
  zIndex: 2,
}));

export const TypeChip = styled(Chip)(() => ({
  position: "absolute",
  top: 8,
  left: 8,
  zIndex: 2,
  maxWidth: "calc(80% - 85px)", // Leave room for status chip
  "& .MuiChip-label": {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

export const PlayIconOverlay = styled(PlayIcon)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  fontSize: 50,
  color: "white",
  opacity: 0.8,
  zIndex: 1,
});
